import { createContext, useContext } from 'react';

import type { ToggleSize, ToggleVariant } from '@/components/buttons/Toggle/Toggle';

export type ToggleGroupOrientation = 'horizontal' | 'vertical';

export type ToggleGroupContextValue = {
  variant: ToggleVariant;
  size: ToggleSize;
  spacing: number;
  orientation: ToggleGroupOrientation;
};

export const ToggleGroupContext = createContext<ToggleGroupContextValue>({
  variant: 'ghost',
  size: 'medium',
  spacing: 0,
  orientation: 'horizontal',
});

export const useToggleGroupContext = () => useContext(ToggleGroupContext);
